import { Coffee, Briefcase, ArrowUpRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { CTA } from "@/lib/config";

const FLOATING_INITIAL = { opacity: 0, y: 30 };
const FLOATING_ANIMATE = { opacity: 1, y: 0 };
const FLOATING_EXIT = { opacity: 0, y: 20 };
const FLOATING_TRANSITION = { duration: 0.25 };

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={FLOATING_INITIAL}
          animate={FLOATING_ANIMATE}
          exit={FLOATING_EXIT}
          transition={FLOATING_TRANSITION}
          className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3"
          data-testid="floating-cta"
        >
          <a
            href={CTA.hireUs}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-hire-us-btn"
            className="group inline-flex items-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-black font-bold px-4 h-11 shadow-[6px_6px_0_0_rgba(0,0,0,0.6)] hover:shadow-[3px_3px_0_0_rgba(0,0,0,0.6)] hover:translate-x-[3px] hover:translate-y-[3px] transition-all"
          >
            <Briefcase className="w-4 h-4" strokeWidth={2.5} />
            <span className="text-sm leading-tight text-left">
              Hire us to run your ads
              <span className="block text-[9px] font-mono uppercase tracking-widest text-black/60 -mt-0.5">
                Got impressed?
              </span>
            </span>
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
          <a
            href={CTA.buyCoffee}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-buy-coffee-btn"
            className="group inline-flex items-center gap-2 bg-black border border-zinc-300 dark:border-zinc-700 hover:border-yellow-500 text-white hover:text-yellow-500 font-semibold px-4 h-11 shadow-[6px_6px_0_0_rgba(234,179,8,0.35)] hover:shadow-[3px_3px_0_0_rgba(234,179,8,0.6)] hover:translate-x-[3px] hover:translate-y-[3px] transition-all"
          >
            <Coffee className="w-4 h-4" strokeWidth={2.5} />
            <span className="text-sm">Buy us a coffee</span>
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
